import React from 'react';

import { Skeleton } from '../loading';

/**
 * The loading-initial placeholders of the signed-out pages (KPR-650;
 * docs/platform-standards.md §14): the share-link page and the intake / public
 * form page. Each takes the footprint of the page that replaces it (same
 * column width, a header, then the body), so nothing moves when it arrives.
 * Generic per surface type, not per field.
 */

/** A share link: header, the one-line note, then a grid of tiles. */
export function PublicViewSkeleton() {
	return (
		<div className="public-skeleton public-skeleton--view" data-testid="public-view-skeleton">
			<div className="public-skeleton__header">
				<Skeleton variant="line" width={72} />
				<Skeleton variant="block" width="55%" height={32} />
				<Skeleton variant="line" width="30%" />
			</div>
			<Skeleton variant="line" width="80%" />
			<PublicTilesSkeleton />
		</div>
	);
}

/** Just the tile grid of a shared view, for the items body of a loaded page. */
export function PublicTilesSkeleton() {
	return <Skeleton variant="tile" count={6} className="public-skeleton__grid" />;
}

/** An intake or public form: a heading, a few fields, and the Send button's place. */
export function PublicFormSkeleton() {
	return (
		<div className="public-skeleton public-skeleton--form" data-testid="public-form-skeleton">
			<div className="public-skeleton__header">
				<Skeleton variant="block" width="60%" height={32} />
				<Skeleton variant="line" width="85%" />
			</div>
			<Skeleton variant="form-field" count={4} />
			<Skeleton variant="block" width={120} height={44} />
		</div>
	);
}
